import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Stack from '@mui/material/Stack';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import { LinearProgress } from '@mui/material';
import Typography from '@mui/material/Typography';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

import { getAutomationFindingsSingle } from 'src/server/store/automation';

import Label from 'src/components/label';

import { formatTime12Hour } from './Tables/AutomationTableRowAutomation';

const FindingsDetailDialog = ({ open, onClose, data, onExecute, onReject }) => {
  const dispatch = useDispatch();
  const findingsId = data?._id;

  const { automationFindingsDetails, singleViewLoading } = useSelector((state) => ({
    automationFindingsDetails: state?.automation?.automationFindingsDetails,
    singleViewLoading: state?.automation?.singleViewLoading,
  }));

  useEffect(() => {
    if (findingsId) {
      dispatch(getAutomationFindingsSingle({ credentials: { id: findingsId } }));
    }
  }, [dispatch, findingsId]);

  if (!automationFindingsDetails) return null;

  console.log(findingsId);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography variant="subtitle1">Automation Finding Details</Typography>
      </DialogTitle>
      <DialogContent dividers>
        {singleViewLoading ? (
          <Stack sx={{ minHeight: '460px' }}>
            <LinearProgress color="success" />
          </Stack>
        ) : (
          <Stack spacing={2}>
            <Typography variant="subtitle1">
              {automationFindingsDetails.automation?.title || '--'}
            </Typography>
            <Typography variant="body2">
              Rule : {automationFindingsDetails.automationRuleTemplate?.title || '--'}
            </Typography>
            <Typography variant="body2">
              Campaign : <b>{automationFindingsDetails.campaignName || '--'}</b>
            </Typography>
            <Typography variant="body2">
              Ad Group : <b>{automationFindingsDetails.adGroupName || '--'}</b>
            </Typography>
            <Typography variant="body2">
              Keyword Id: <b>{automationFindingsDetails.keywordId || '--'}</b>
            </Typography>
            <Divider />
            <Stack direction="row" spacing={2}>
              <Typography variant="body2">
                Execution Type : <b>{automationFindingsDetails.executionType || '--'}</b>
              </Typography>
              <Typography variant="body2">
                Frequency :{' '}
                <b>{automationFindingsDetails.automation?.schedule?.frequency || '--'}</b>
              </Typography>
            </Stack>
            <Typography variant="body2">
              Scheduled Time :{' '}
              {automationFindingsDetails?.automation?.schedule?.time
                ? `${formatTime12Hour(automationFindingsDetails?.automation?.schedule?.time)} ${
                    automationFindingsDetails.automation?.schedule?.timezone || '--'
                  }`
                : '--'}
            </Typography>
            <Typography variant="body2">
              Apply Date :{' '}
              {automationFindingsDetails.executedAt
                ? new Date(automationFindingsDetails.executedAt).toLocaleString()
                : '--'}
            </Typography>
            <Label
              variant="soft"
              color={automationFindingsDetails.executionStatus === 'Active' ? 'success' : 'default'}
              sx={{ textTransform: 'uppercase', width: 'fit-content' }}
            >
              {automationFindingsDetails.executionStatus || '--'}
            </Label>
            <Divider />
            <Typography variant="subtitle2">Summary </Typography>
            <Typography variant="body2">{automationFindingsDetails.summary || '--'}</Typography>
          </Stack>
        )}
      </DialogContent>
      <DialogActions>
        {automationFindingsDetails.executionStatus !== 'REJECTED' && (
          <>
            <Button onClick={onReject} color="error" variant="outlined">
              Reject
            </Button>
            <Button onClick={onExecute} color="success" variant="contained">
              Execute
            </Button>
          </>
        )}
        <Button onClick={onClose} color="inherit" variant="text">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

FindingsDetailDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  data: PropTypes.object,
  onExecute: PropTypes.func,
  onReject: PropTypes.func,
};

export default FindingsDetailDialog;
